import * as actionTypes from 'actions/action-types'
import entityReducer from 'lib/redux-crud/entityReducer'

export default entityReducer({
  name: 'images',
  entityTypes: actionTypes,
  identifierForEntity: entity => entity.uuid,
})
